import styled from "styled-components/native";
import { spacing } from "../theme";

export const OverviewDeleteModalButtonWrapper = styled.View`
  margin-top: ${spacing.medium};
  flex-direction: row;
  justify-content: center;
`;
